import { evaluateStateAccess } from "app/components/React/QuickSearch/pageData/evaluateStateAccess";
import type { SidebarAccessMap } from "app/components/React/QuickSearch/pageData/getSidebarAccessMap";

export type AccessibleItem<T> = {
    readonly item: T;
    readonly isLocked: boolean;
    readonly hookKey?: string;
};

export const filterAccessibleItems = <T>(
    items: readonly T[],
    sidebarAccessMap: SidebarAccessMap,
    getUiRouterState: (item: T) => string | undefined,
): AccessibleItem<T>[] =>
    items.reduce<AccessibleItem<T>[]>((acc, item) => {
        const verdict = evaluateStateAccess(getUiRouterState(item), sidebarAccessMap);

        if (verdict.kind === "drop") {
            return acc;
        }

        acc.push(
            verdict.kind === "lock" ? { item, isLocked: true, hookKey: verdict.hookKey } : { item, isLocked: false },
        );

        return acc;
    }, []);
